import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import type { Nullable } from '@ps/utils';
import { SupplierActions } from './supplier.actions';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';
import { SupplierBlendSave } from '../models/supplier-blend.model';
import { SupplierGroupTemplateSave } from '../models/supplier-group-template.model';

@Injectable({ providedIn: 'root' })
export class SupplierActionsFacade {
  private readonly _store = inject(Store);

  public loadSuppliers(
    buyerId: number,
    countryId?: Nullable<number>,
    languageId?: Nullable<number>,
  ): void {
    this._store.dispatch(
      SupplierActions.loadSuppliers({ buyerId, countryId, languageId }),
    );
  }

  public updateSupplier(id: number, data: Partial<Supplier>): void {
    this._store.dispatch(SupplierActions.updateSupplier({ id, data }));
  }

  public saveSupplierAccess(data: SupplierAccessSave): void {
    this._store.dispatch(SupplierActions.saveSupplierAccess(data));
  }

  public loadSupplierBlends(): void {
    this._store.dispatch(SupplierActions.loadSupplierBlends());
  }

  public deleteSupplierBlend(id: string): void {
    this._store.dispatch(SupplierActions.deleteSupplierBlend({ id }));
  }

  public setSupplierBlendDefault(id: string, isDefault: boolean): void {
    this._store.dispatch(
      SupplierActions.setSupplierBlendDefault({ id, isDefault }),
    );
  }

  public lockAllSupplierBlends(isLocked: boolean): void {
    this._store.dispatch(SupplierActions.lockAllSupplierBlends({ isLocked }));
  }

  public openCreateBlendForm(): void {
    this._store.dispatch(SupplierActions.openCreateSupplierBlendForm());
  }

  public openEditBlendForm(id: string): void {
    this._store.dispatch(SupplierActions.openEditSupplierBlendForm({ id }));
  }

  public closeBlendForm(): void {
    this._store.dispatch(SupplierActions.closeSupplierBlendForm());
  }

  public createSupplierBlend(data: SupplierBlendSave): void {
    this._store.dispatch(SupplierActions.createSupplierBlend({ data }));
  }

  public updateSupplierBlend(
    id: string,
    data: SupplierBlendSave,
    keepFormOpen: boolean,
  ): void {
    this._store.dispatch(
      SupplierActions.updateSupplierBlend({ id, data, keepFormOpen }),
    );
  }

  public loadGroupTemplates(): void {
    this._store.dispatch(SupplierActions.loadGroupTemplates());
  }

  public saveGroupAsTemplate(data: SupplierGroupTemplateSave): void {
    this._store.dispatch(SupplierActions.saveGroupAsTemplate({ data }));
  }
}
